module.exports = __webpack_public_path__ + "static/media/niebieski_stres.29813ef8.png";